import { VdTracking } from '@vend/vend.js'

/**
 * Controller class for the outlets differ sale modal
 *
 * @class OutletsDifferModalController
 */
export class OutletsDifferModalController {
  public displaySaleStatus: $TSFixMe
  public outletName: $TSFixMe
  constructor(
    public close: $TSFixMe,
    options: $TSFixMe,
    vdTracking: VdTracking,
    wrSaleStatusFilter: $TSFixMe
  ) {
    'ngInject'
    this.displaySaleStatus = wrSaleStatusFilter({ status: options.saleStatus })
    this.outletName = options.saleOutletName

    vdTracking.trackUserEvent({
      eventName: 'Sale Made on Different Outlet Warning',
    })
  }
}
